import LeopartLoader from "../../shared/LeopartLoader/LeopartLoader";
import { FC, useEffect, useMemo, useState } from "react";
import { useEndpoints } from "../../hooks/useEndpoints";
import { useParams, useSearchParams } from "react-router-dom";
import LeopartOnDarkvector from "../../assets/icons/LeopartOnDarkvector";
import { IslandIcon } from "@phosphor-icons/react";
import { IEndpointsResponse } from "../../typings/endpoints";
import { useSimpleForm } from "../../hooks/useSimpleForm";
import CustomCard from "../../shared/Card/CustomCard";
import CustomButton from "../../shared/CustomButton/CustomButton";
import CustomPasswordInput from "../../shared/CustomPasswordInput/CustomPasswordInput";
import Typhography from "../../shared/Typhography/Typhography";
import { RegistrationStepper } from "../../components/ConfirmTokenPage/RegistrationStepper/RegistrationStepper";
import style from "./ConfirmTokenPage.module.scss";
export const ConfirmTokenPage: FC = () => {
  const { verifyToken } = useEndpoints();
  const [error, setError] = useState(false);
  const [data, setData] = useState<IEndpointsResponse["verifyToken"] | null>();
  const [isLoading, setIsLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const { form, handleEventInputChange, handleChange } = useSimpleForm({
    password: "",
    confirmPassword: "",
    token: "",
  });
  const token = useMemo(() => searchParams.get("token") as string, []);

  const fetchVerifyToken = async () => {
    setIsLoading(true);
    try {
      const { data: response } = await verifyToken({
        token: searchParams.get("token")!,
      });
      setData(response);
    } catch (error) {
      setData(null);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const securityPassword = useMemo(() => {
    const conditions = [
      /\d/.test(form.password),
      // eslint-disable-next-line
      /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(form.password),
      form.password.length >= 10,
    ];
    const trueConditions = conditions.filter(Boolean).length;
    return {
      percentual: Number((trueConditions / conditions.length) * 100).toFixed(0),
      number: trueConditions,
      label:
        trueConditions === 0 || trueConditions === 1
          ? "Bassa"
          : trueConditions === 2
          ? "Media"
          : "alta",
      colorLine:
        trueConditions === 0 || trueConditions === 1
          ? "error"
          : trueConditions === 2
          ? "warning"
          : "success",
    };
  }, [form.password]);

  useEffect(() => {
    fetchVerifyToken();
  }, []);
  const renderLoading = () => {
    return (
      <div className="w-100 h-100 d-flex align-items-center justify-content-center">
        <LeopartLoader />
      </div>
    );
  };

  const renderHeader = () => {
    return (
      <div className="header text-medium-14">
        <div className="d-flex align-items-center">
          <LeopartOnDarkvector w={"44px"} h={"44px"} />
          <span className="title">Leopart</span>
        </div>
      </div>
    );
  };

  const renderError = () => {
    return (
      <>
        <Typhography size="bold-24" className="mb-3">
          Errore
        </Typhography>
        <Typhography size="bold-12" className="mb-3">
          Link non valido
        </Typhography>
      </>
    );
  };

  return (
    <div className="container-login-page">
      <div className="container__header">
        {renderHeader()}
        <div className={`container__form ${style.containerForm}`}>
          {isLoading ? (
            renderLoading()
          ) : data === null ? (
            renderError()
          ) : (
            <RegistrationStepper data={data!} token={token} />
          )}
        </div>
      </div>
    </div>
  );
};
